export const MUTATION_ADD_DESIGNS = 'ADD_DESIGNS';
export const MUTATION_REPLACE_DESIGNS = 'REPLACE_DESIGNS';
export const MUTATION_SET_FILTERS = 'SET_FILTERS';
export const MUTATION_SET_PRINT_SIDE = 'SET_PRINT_SIDE';
export const MUTATION_SET_PRODUCTS = 'SET_PRODUCTS';
export const MUTATION_UPDATE_FILTERS = 'UPDATE_FILTERS';
export const MUTATION_LOAD_PRINT_PLATE_DIMENSIONS =
  'LOAD_PRINT_PLATE_DIMENSIONS';
export const MUTATION_SEARCH_DESIGNS = 'SEARCH_DESIGNS';
export const MUTATION_CLEAR_SEARCH = 'MUTATION_CLEAR_SEARCH';
export const MUTATION_HIDE_NAVIGATION = 'MUTATION_HIDE_NAVIGATION';
export const MUTATION_SHOW_NAVIGATION = 'MUTATION_SHOW_NAVIGATION';
export const MUTATION_DISABLE_PRODUCT_CHANGE =
  'MUTATION_DISABLE_PRODUCT_CHANGE';
export const MUTATION_SET_LOCALE = 'SET_LOCALE';
